export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/unzipWorker.69cd1e13.worker.js");
}
